import { render, staticRenderFns } from "./testAuthority.vue?vue&type=template&id=12663816&scoped=true&"
import script from "./testAuthority.vue?vue&type=script&lang=js&"
export * from "./testAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12663816",
  null
  
)

export default component.exports